import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import UpdateSubscriptionDialogContent from './UpdateSubscriptionDialogContent';
import { VpStripeElementsWrapper } from '../../wrappers/VpStripeElementsWrapper';
import { VpDialogTitle } from '../../components';
import { VpDialogContent } from '../../components';

export const VpUpdateSubscriptionDialog = ({
  plan = '',
  open = false,
  onClose = null,
  onUpdateClick,
  refreshAuthStateAction
}) => {
  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      <VpDialogTitle onClose={onClose} leftContent="Order Confirmation" />
      <VpDialogContent>
        <VpStripeElementsWrapper>
          <UpdateSubscriptionDialogContent
            onClose={onClose}
            plan={plan}
            onUpdateClick={onUpdateClick}
            refreshAuthStateAction={refreshAuthStateAction}
          />
        </VpStripeElementsWrapper>
      </VpDialogContent>
    </Dialog>
  );
};

VpUpdateSubscriptionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  plan: PropTypes.string.isRequired,
  onUpdateClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  refreshAuthStateAction: PropTypes.func
};

export default VpUpdateSubscriptionDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpUpdateSubscriptionDialog/VpUpdateSubscriptionDialog.jsx